import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../../utils/Utils.js';
import ErrorMessage from '../../shared/ErrorMessage.js';
import '../../shared/DataCollectionAdd.css';

// AddProject creates a project; the API assigns its PROJ-NNNN code. Same
// look as the other add forms (DataCollectionAdd), but posts to
// /api/finance/projects instead of the generic data endpoint.
export const AddProject = ({ onSuccess }) => {
  const { t } = useTranslation();
  const [name,    setName]    = useState('');
  const [matches, setMatches] = useState('');
  const [saving,  setSaving]  = useState(false);
  const [error,   setError]   = useState('');

  const submit = (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    Fetch('api/finance/projects', 'POST', JSON.stringify({ name, matches }),
      (created) => { setSaving(false); onSuccess?.(created); },
      (message) => { setSaving(false); setError(message); }
    );
  };

  return (
    <form className="DataCollectionAdd" onSubmit={submit}>
      <input type="text" value={name} onChange={e => setName(e.target.value)}
             placeholder={t('project_name_placeholder')} required autoFocus />
      <input type="text" value={matches} onChange={e => setMatches(e.target.value)}
             placeholder={t('project_nicknames_placeholder')} />
      <button type="submit" disabled={saving || !name.trim()}>{t('add_button')}</button>
      <ErrorMessage message={error} />
    </form>
  );
};

export default AddProject;
